module.exports = __webpack_public_path__ + "img/16.a42e5842.png";